import GlobalStyle from './style';
import SEO from './Components/SEO';
import Header from './Components/Header';
import Container from './Components/Container';
import Hero from './Components/Hero';
import About from './Components/About';
import Services from './Components/Services';
import Differences from './Components/Differences';
import Footer from './Components/Footer';

function App() {
  return (
    <>
      <SEO />
      <GlobalStyle />
      <Header />
      <Container color="white">
        <main>
          <Hero />
        </main>
      </Container>
      <Container color="lightgrey">
        <section aria-label="Serviços">
          <Services />
        </section>
      </Container>
      <Container color="white">
        <section aria-label="Diferenciais">
          <Differences />
        </section>
      </Container>
      <Container color="white">
        <section aria-label="Sobre nós">
          <About />
        </section>
      </Container>
      <Footer />
    </>
  );
}

export default App;
